import { css } from "glamor";
import { Button } from "antd";

import sharedStyles from "./sharedStyles";

// Weird stuff is happening with styles
// specificity here. Library styles are
// not overidden when they should be, hence
// the crazy number of !important
const styles = {
    main: css({
        color: "white !important",
        backgroundColor: "#01b0f0 !important",
        borderColor: "#01b0f0 !important",
        ":hover": {
            backgroundColor: "#1990FF !important",
            borderColor: "#1990FF !important",
        },
        ":disabled": {
            opacity: "0.25 !important",
        },
    }),
    reverse: css({
        color: "#01b0f0 !important",
        backgroundColor: "white !important",
        borderColor: "#01b0f0 !important",
        ":hover": {
            borderColor: "#1990FF !important",
            color: "#1990FF !important",
        },
        ":disabled": {
            opacity: "0.25 !important",
        },
    }),
};

const Secondary = ({ children, reverse, size, onClick, ...rest }) => {
    const buttonStyles = (reverse && styles.reverse) || styles.main;

    const appliedSize = size
        ? sharedStyles.size[size]
        : sharedStyles.size.default;

    const appliedStyles = {
        ...buttonStyles,
        ...appliedSize,
    };
    return (
        <Button {...appliedStyles} {...rest} onClick={onClick}>
            {children}
        </Button>
    );
};

export default Secondary;
